import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactComponent as Flags404 } from '@backrs_ui/common-ui/src/assets/images/404-image.svg';
import { Box, Button, Typography } from '@mui/material';
import { appStrings } from '../assets/appStrings';
import { TYPOGRAPHY_VARIANTS } from '../designSystem/typography/typography';
var NOT_FOUND_STRINGS = appStrings.modules.notFound404;
export var NotFound404 = function (_a) {
    var onClick = _a.onClick;
    return (_jsxs(Box, { sx: containerSx, children: [_jsx(Box, { sx: imageContainerSx, children: _jsx(Flags404, {}) }), _jsx(Typography, { sx: notFoundTextSx, variant: "display-xl-medium", children: NOT_FOUND_STRINGS.title }), onClick && (_jsx(Button, { onClick: onClick, variant: "contained", children: NOT_FOUND_STRINGS.action }))] }));
};
var containerSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100svh',
    gap: { xs: '2rem', sm: '4rem' },
    width: '100%',
};
var notFoundTextSx = {
    textAlign: 'center',
    fontSize: {
        xs: '32px',
        sm: TYPOGRAPHY_VARIANTS['display-xl-medium'].fontSize,
    },
};
var imageContainerSx = {
    svg: {
        width: '100%',
        height: '100%',
    },
};
